import type { RouteLocationNormalized } from "vue-router";

import { Schulform } from "@core/asd/types/schule/Schulform";
import { BenutzerKompetenz } from "@core/core/types/benutzer/BenutzerKompetenz";
import { ServerMode } from "@core/core/types/ServerMode";
import { useNotenmodulState } from "@ui/states/NotenmodulState";

import type { NotenmodulKlassenleitungProps } from "~/components/notenmodul/NotenmodulKlassenleitungProps";
import { RouteNode } from "~/router/RouteNode";

import { type RouteNotenmodulKlassenleitung, routeNotenmodulKlassenleitung } from "./RouteNotenmodulKlassenleitung";

const NotenmodulKlassenleitung = () => import("~/components/notenmodul/NotenmodulKlassenleitung.vue");

export class RouteNotenmodulKlassenleitungData extends RouteNode<any, RouteNotenmodulKlassenleitung> {

	public constructor() {
		super(Schulform.values(), [
			BenutzerKompetenz.NOTENMODUL_ADMINISTRATION,
			BenutzerKompetenz.NOTENMODUL_NOTEN_ANSEHEN_ALLGEMEIN,
			BenutzerKompetenz.NOTENMODUL_NOTEN_ANSEHEN_FUNKTION,
			BenutzerKompetenz.NOTENMODUL_NOTEN_AENDERN_ALLGEMEIN,
			BenutzerKompetenz.NOTENMODUL_NOTEN_AENDERN_FUNKTION,
		], "notenmodul.klassenleitung.daten", "daten", NotenmodulKlassenleitung);
		super.mode = ServerMode.STABLE;
		super.propHandler = (route) => this.getProps(route);
		super.text = "Klassenleitung";
	}

	public getProps(to: RouteLocationNormalized): NotenmodulKlassenleitungProps {
		const notenmodulState = useNotenmodulState();
		return {
			enmManager: () => notenmodulState.manager,
			auswahl: () => notenmodulState.auswahlKlassen,
			patchBemerkungen: notenmodulState.patchBemerkungen,
			patchLernabschnitt: notenmodulState.patchLernabschnitt,
			columnsVisible: () => routeNotenmodulKlassenleitung.data.columnsVisible,
			setColumnsVisible: routeNotenmodulKlassenleitung.data.setColumnsVisible,
		};
	}

}

export const routeNotenmodulKlassenleitungData = new RouteNotenmodulKlassenleitungData();
